import React from 'react';
import AreasList from '../../components/areas/AreasList';

export default function AreaManagement() {
    return (
        <AreasList />
    );
}

